import { BellSleepIcon } from './BellSleepIcon';

/**
 * author: Google
 * id 43BD9E91-2044-4B80-AF87-2FC810C42A1B
 * name bell-sleep
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/bell-sleep.svg
 * tags
 * - Notification 
 */
export const NotificationsPausedIcon = BellSleepIcon;
export default NotificationsPausedIcon